// Chatbot program metadata (labels + targets). Descriptions come from admin settings.
export const CHATBOT_PROGRAMS = {
  efk: { label: "English for Kids (EFK)", target: "TKB – SD1" },
  eyl: { label: "English for Young Learners (EYL)", target: "SD2 – SD6" },
  efj: { label: "English for Juniors (EFJ)", target: "SMP1 – SMP3" },
  ge: { label: "General English for Communication (GE)", target: "SMA, Mahasiswa, Karyawan & Umum" },
  toefl: { label: "TOEFL Preparation / Prediction", target: "Umum" },
  toeic: { label: "TOEIC Preparation", target: "Umum" },
  ielts: { label: "IELTS Preparation", target: "Umum" },
  school: { label: "School Extracurricular Program", target: "Sekolah", lembaga: true },
  corporate: { label: "In-Company / Corporate Training", target: "Perusahaan", lembaga: true },
  private: { label: "Private Program", target: "Individu" },
};

export const CHATBOT_FALLBACK = "Untuk jadwal dan biaya terbaru, silakan isi data minat atau hubungi Admin IEC Mustikajaya.";

export const WA_PRESET = "Halo Admin IEC Mustikajaya, saya ingin mendapatkan informasi program Bahasa Inggris.";

export const INDIVIDU_CATEGORIES = ["Siswa SD", "Siswa SMP", "Siswa SMA", "Mahasiswa", "Karyawan", "Orang tua siswa"];
export const LEMBAGA_TYPES = ["Sekolah", "Yayasan Pendidikan", "Lembaga Pendidikan", "Lembaga Sosial", "Corporate", "Instansi Pemerintah", "Lainnya"];
export const MODES = ["Offline", "Online", "Hybrid"];

// Kategori program untuk submenu "Cari Program"
export const PROGRAM_CATEGORIES = [
  { id: "anak", label: "Program untuk Anak", programs: ["efk", "eyl"] },
  { id: "remaja", label: "Program untuk Remaja", programs: ["efj"] },
  { id: "dewasa", label: "Program untuk Dewasa", programs: ["ge"] },
  { id: "tes", label: "TOEFL/TOEIC/IELTS", programs: ["toefl", "toeic", "ielts"] },
  { id: "sekolah", label: "Program Sekolah", lembagaForm: "school" },
  { id: "perusahaan", label: "Program Perusahaan", lembagaForm: "corporate" },
];

// Menu utama widget: 5 pilihan sesuai struktur yang direkomendasikan.
export const MAIN_MENU = [
  { id: "cari", label: "Cari Program", browse: true },
  { id: "daftar", label: "Daftar Sekarang", register: true },
  { id: "hubungi", label: "Hubungi Admin", contact: true },
  { id: "faq", label: "FAQ / Pertanyaan Populer", faq: true },
  { id: "lokasi", label: "Lokasi IEC Mustikajaya", info: "address" },
];

// Topik ringan untuk alur "Hubungi Admin" (langsung ke WhatsApp, tanpa formulir)
export const CONTACT_TOPICS = [
  { id: "program", label: "Tanya Program", text: "Halo Admin IEC, saya ingin bertanya tentang program kursus Bahasa Inggris." },
  { id: "biaya", label: "Tanya Biaya", text: "Halo Admin IEC, saya ingin bertanya tentang biaya dan program kursus Bahasa Inggris." },
  { id: "jadwal", label: "Tanya Jadwal", text: "Halo Admin IEC, saya ingin bertanya tentang jadwal belajar." },
  { id: "online", label: "Tanya Kelas Online", text: "Halo Admin IEC, saya ingin bertanya tentang kelas online." },
  { id: "lokasi", label: "Tanya Lokasi Cabang", text: "Halo Admin IEC, saya ingin bertanya tentang lokasi cabang IEC." },
  { id: "konsultasi", label: "Konsultasi Program", text: "Halo Admin IEC, saya ingin berkonsultasi memilih program yang sesuai." },
  { id: "lainnya", label: "Pertanyaan Lainnya", text: "Halo Admin IEC, saya ingin bertanya seputar kursus Bahasa Inggris." },
];

// FAQ / Pertanyaan Populer. cfgKey memakai data pengaturan chatbot jika tersedia;
// jika kosong, jawaban aman `a` yang dipakai (tidak mengarang harga/jadwal/promo).
export const FAQ_ITEMS = [
  { q: "Kursus IEC cocok untuk siapa?", a: "IEC melayani anak-anak, remaja, mahasiswa, karyawan, dan umum, serta program khusus untuk sekolah dan perusahaan." },
  { q: "Apakah pemula bisa ikut?", a: "Tentu. Tersedia kelas untuk berbagai level termasuk pemula. Level akan disesuaikan melalui konsultasi/placement singkat." },
  { q: "Program apa yang cocok untuk anak?", a: "Untuk anak tersedia English for Kids (EFK) dan English for Young Learners (EYL). Pilih menu \u201CProgram untuk Anak\u201D untuk detailnya." },
  { q: "Apakah tersedia kelas online?", a: "Ya, tersedia mode Offline, Online, dan Hybrid tergantung program dan cabang." },
  { q: "Bagaimana cara mengetahui level?", a: "Level ditentukan melalui placement/konsultasi singkat bersama tim IEC sebelum kelas dimulai." },
  { q: "Berapa biaya kursus?", cfgKey: "cost_info", a: "Biaya berbeda menurut program, jenis kelas, dan cabang. Silakan pilih \u201CHubungi Admin\u201D untuk info biaya terbaru." },
  { q: "Bagaimana jadwal belajarnya?", cfgKey: "schedule_info", a: "Jadwal menyesuaikan program dan cabang. Silakan pilih \u201CHubungi Admin\u201D untuk jadwal terbaru." },
  { q: "Apakah tersedia trial class?", a: "Ketersediaan trial class dapat berbeda tiap periode dan cabang. Silakan tanyakan langsung melalui \u201CHubungi Admin\u201D." },
  { q: "Di mana lokasi cabang IEC?", cfgKey: "address", a: "Silakan pilih \u201CLokasi Cabang\u201D pada menu atau hubungi Admin untuk alamat lengkap dan peta." },
  { q: "Bagaimana cara mendaftar?", a: "Mudah. Klik \u201CDaftar Sekarang\u201D di menu, isi formulir singkat, lalu tim IEC akan menghubungi Anda untuk konfirmasi program dan jadwal." },
];

export function normalizeWaLink(phone) {
  if (!phone) return "";
  const digits = String(phone).replace(/[^0-9]/g, "");
  if (!digits) return "";
  let d = digits;
  if (d.startsWith("0")) d = "62" + d.slice(1);
  else if (d.startsWith("8")) d = "62" + d;
  return `https://wa.me/${d}?text=${encodeURIComponent(WA_PRESET)}`;
}

// Sama seperti normalizeWaLink tetapi dengan pesan awal khusus per topik.
export function waLinkWithText(phone, text) {
  if (!phone) return "";
  const digits = String(phone).replace(/[^0-9]/g, "");
  if (!digits) return "";
  let d = digits;
  if (d.startsWith("0")) d = "62" + d.slice(1);
  else if (d.startsWith("8")) d = "62" + d;
  return `https://wa.me/${d}?text=${encodeURIComponent(text || WA_PRESET)}`;
}
